/**
 * Elenco delle lingue supportate. `code` = codice i18n, `native` = nome
 * nella lingua stessa (mostrato nello switcher), `it` = nome italiano (usato
 * per ordinare la lista alfabeticamente, come richiesto).
 *
 * Italiano è la lingua base (fallback). Le traduzioni vivono in
 * src/i18n/resources.ts (per ora un set "common" di partenza; le ~700 stringhe
 * dell'app verranno estratte a ondate successive).
 */
export interface LanguageMeta {
  code: string;
  native: string;
  it: string;
}

export const LANGUAGES: LanguageMeta[] = [
  { code: 'bn', native: 'বাংলা', it: 'Bangla' },
  { code: 'zh', native: '中文', it: 'Cinese' },
  { code: 'da', native: 'Dansk', it: 'Danese' },
  { code: 'fil', native: 'Filipino', it: 'Filippino' },
  { code: 'fi', native: 'Suomi', it: 'Finlandese' },
  { code: 'fr', native: 'Français', it: 'Francese' },
  { code: 'ja', native: '日本語', it: 'Giapponese' },
  { code: 'en', native: 'English', it: 'Inglese' },
  { code: 'it', native: 'Italiano', it: 'Italiano' },
  { code: 'nb', native: 'Norsk', it: 'Norvegese' },
  { code: 'pt', native: 'Português', it: 'Portoghese' },
  { code: 'ru', native: 'Русский', it: 'Russo' },
  { code: 'es', native: 'Español', it: 'Spagnolo' },
  { code: 'de', native: 'Deutsch', it: 'Tedesco' },
].sort((a, b) => a.it.localeCompare(b.it, 'it'));

export const LANGUAGE_CODES = LANGUAGES.map((l) => l.code);

export const DEFAULT_LANGUAGE = 'it';

/** Mappa code → locale BCP-47 per Intl (date/numeri/valute). */
export const INTL_LOCALE: Record<string, string> = {
  it: 'it-IT', en: 'en-US', es: 'es-ES', fr: 'fr-FR', de: 'de-DE',
  bn: 'bn-BD', ru: 'ru-RU', zh: 'zh-CN', ja: 'ja-JP', fil: 'fil-PH',
  da: 'da-DK', fi: 'fi-FI', nb: 'nb-NO', pt: 'pt-PT',
};
